var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwishPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 139,
    viewBox: "0 0 192 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2545_980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.26 137.468L145.22 117.078H137",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.88 93.8391L137 84.0391",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.04 8.39062H93.6199C92.902 8.39062 92.3199 8.97265 92.3199 9.69062C92.3199 10.4086 92.902 10.9906 93.6199 10.9906H111.04C111.758 10.9906 112.34 10.4086 112.34 9.69062C112.34 8.97265 111.758 8.39062 111.04 8.39062Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.14 35.46V13.89C70.1505 10.4798 71.5078 7.21179 73.9164 4.79758C76.325 2.38337 79.5898 1.01845 83 1H124.08C127.501 1.00263 130.781 2.36057 133.202 4.77648C135.624 7.1924 136.989 10.4694 137 13.89V25.79",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.46 96.7486L171.55 77.1786L162.33 40.6486C161.512 37.4009 159.77 34.4597 157.316 32.181C154.862 29.9023 151.799 28.3836 148.5 27.8086L114.05 21.8086L113.24 26.2986C112.443 30.8365 113.41 35.5075 115.944 39.3556C118.478 43.2037 122.386 45.9379 126.87 46.9986L137 49.5486V120.869C136.992 124.286 135.632 127.561 133.216 129.978C130.801 132.395 127.527 133.758 124.11 133.769H83C79.5829 133.758 76.3089 132.395 73.8935 129.978C71.4782 127.561 70.1179 124.286 70.11 120.869V104.869",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7601 36.9016C76.7916 36.9016 78.74 37.7086 80.1765 39.1451C81.613 40.5817 82.4201 42.53 82.4201 44.5616V44.9116C82.4174 46.9423 81.6095 48.8891 80.1736 50.3251C78.7376 51.761 76.7908 52.5689 74.7601 52.5716H64.0001C61.9693 52.5689 60.0225 51.761 58.5865 50.3251C57.1506 48.8891 56.3427 46.9423 56.3401 44.9116V44.5616C56.3427 42.5308 57.1506 40.584 58.5865 39.1481C60.0225 37.7121 61.9693 36.9042 64.0001 36.9016H74.7601ZM74.7601 35.1016H64.0001C62.7582 35.1016 61.5286 35.3463 60.3814 35.8219C59.2342 36.2974 58.192 36.9944 57.3144 37.8729C56.4367 38.7515 55.7408 39.7945 55.2665 40.9421C54.7922 42.0898 54.5487 43.3197 54.5501 44.5616V44.9116C54.5501 47.4188 55.5454 49.8235 57.3173 51.5973C59.0892 53.3711 61.4928 54.3689 64.0001 54.3716H74.7601C77.269 54.3716 79.6752 53.3749 81.4493 51.6008C83.2234 49.8267 84.2201 47.4205 84.2201 44.9116V44.5616C84.2214 43.3189 83.9776 42.0882 83.5026 40.9398C83.0277 39.7915 82.3309 38.7481 81.4522 37.8694C80.5735 36.9907 79.5301 36.2939 78.3818 35.819C77.2335 35.344 76.0027 35.1003 74.7601 35.1016Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.61 54.5312C74.6238 54.6035 76.531 55.4543 77.9301 56.9045C79.3292 58.3547 80.1111 60.2912 80.1111 62.3063C80.1111 64.3213 79.3292 66.2578 77.9301 67.708C76.531 69.1582 74.6238 70.009 72.61 70.0813H61.31C60.2655 70.1187 59.2241 69.9453 58.2481 69.5715C57.2721 69.1976 56.3815 68.6309 55.6293 67.9053C54.8771 67.1796 54.2789 66.3098 53.8703 65.3478C53.4617 64.3859 53.2511 63.3514 53.2511 62.3063C53.2511 61.2611 53.4617 60.2266 53.8703 59.2647C54.2789 58.3027 54.8771 57.4329 55.6293 56.7072C56.3815 55.9816 57.2721 55.4149 58.2481 55.041C59.2241 54.6672 60.2655 54.4938 61.31 54.5312H72.61ZM72.61 52.5312H61.31C58.7294 52.5313 56.2545 53.5564 54.4298 55.3811C52.6051 57.2058 51.58 59.6807 51.58 62.2612C51.5786 63.5399 51.8293 64.8062 52.3177 65.9878C52.8061 67.1695 53.5226 68.2433 54.4263 69.1479C55.3299 70.0524 56.403 70.77 57.5841 71.2596C58.7653 71.7492 60.0314 72.0013 61.31 72.0013H72.61C75.1888 71.9986 77.6611 70.9723 79.4836 69.1479C81.3062 67.3234 82.33 64.8501 82.33 62.2713C82.33 59.6924 81.3062 57.2191 79.4836 55.3946C77.6611 53.5702 75.1888 52.5439 72.61 52.5413V52.5312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6 72.1495C73.6444 72.1121 74.6858 72.2854 75.6618 72.6593C76.6378 73.0332 77.5285 73.5998 78.2806 74.3255C79.0328 75.0512 79.631 75.921 80.0396 76.8829C80.4482 77.8449 80.6588 78.8794 80.6588 79.9245C80.6588 80.9697 80.4482 82.0041 80.0396 82.9661C79.631 83.9281 79.0328 84.7979 78.2806 85.5236C77.5285 86.2492 76.6378 86.8159 75.6618 87.1898C74.6858 87.5636 73.6444 87.737 72.6 87.6995H61.31C60.2655 87.737 59.2241 87.5636 58.2481 87.1898C57.2721 86.8159 56.3814 86.2492 55.6293 85.5236C54.8771 84.7979 54.2789 83.9281 53.8703 82.9661C53.4617 82.0041 53.2511 80.9697 53.2511 79.9245C53.2511 78.8794 53.4617 77.8449 53.8703 76.8829C54.2789 75.921 54.8771 75.0512 55.6293 74.3255C56.3814 73.5998 57.2721 73.0332 58.2481 72.6593C59.2241 72.2854 60.2655 72.1121 61.31 72.1495H72.6ZM72.6 70.1495H61.31C60.0066 70.1077 58.7082 70.3283 57.4918 70.7983C56.2754 71.2682 55.1658 71.9778 54.2291 72.885C53.2923 73.7922 52.5475 74.8784 52.0388 76.0791C51.5302 77.2798 51.2681 78.5705 51.2681 79.8745C51.2681 81.1785 51.5302 82.4693 52.0388 83.67C52.5475 84.8707 53.2923 85.9569 54.2291 86.8641C55.1658 87.7713 56.2754 88.4809 57.4918 88.9508C58.7082 89.4207 60.0066 89.6413 61.31 89.5995H72.6C73.9033 89.6413 75.2017 89.4207 76.4182 88.9508C77.6346 88.4809 78.7441 87.7713 79.6808 86.8641C80.6176 85.9569 81.3624 84.8707 81.8711 83.67C82.3797 82.4693 82.6418 81.1785 82.6418 79.8745C82.6418 78.5705 82.3797 77.2798 81.8711 76.0791C81.3624 74.8784 80.6176 73.7922 79.6808 72.885C78.7441 71.9778 77.6346 71.2682 76.4182 70.7983C75.2017 70.3283 73.9033 70.1077 72.6 70.1495Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 89.7391C77.9289 89.7037 78.8553 89.8561 79.7239 90.1872C80.5925 90.5183 81.3854 91.0212 82.0551 91.6659C82.7248 92.3106 83.2575 93.0837 83.6214 93.9391C83.9853 94.7945 84.1728 95.7145 84.1728 96.6441C84.1728 97.5736 83.9853 98.4936 83.6214 99.349C83.2575 100.204 82.7248 100.978 82.0551 101.622C81.3854 102.267 80.5925 102.77 79.7239 103.101C78.8553 103.432 77.9289 103.584 77 103.549H66.59C64.8041 103.481 63.1141 102.724 61.8746 101.436C60.6352 100.149 59.9428 98.4312 59.9428 96.6441C59.9428 94.8569 60.6352 93.1393 61.8746 91.8518C63.1141 90.5643 64.8041 89.807 66.59 89.7391H77ZM77 87.7891H66.59C64.2419 87.7891 61.9898 88.7212 60.3285 90.3806C58.6673 92.04 57.7326 94.291 57.73 96.6391C57.73 98.9889 58.6634 101.242 60.325 102.904C61.9866 104.566 64.2402 105.499 66.59 105.499H77C79.3498 105.499 81.6034 104.566 83.2649 102.904C84.9265 101.242 85.86 98.9889 85.86 96.6391C85.8573 94.291 84.9227 92.04 83.2614 90.3806C81.6001 88.7212 79.3481 87.7891 77 87.7891Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.48 85.8584C100.194 87.6317 104.427 87.9898 108.385 86.8656C112.344 85.7415 115.757 83.2122 117.985 79.7519C120.212 76.2915 121.102 72.1376 120.486 68.0686C119.87 63.9996 117.792 60.2947 114.64 57.6484L109.89 63.3084C112.57 65.5631 114.246 68.7892 114.55 72.2783C114.853 75.7675 113.76 79.2346 111.51 81.9184C109.725 84.0469 107.323 85.5689 104.637 86.2746C101.95 86.9803 99.1105 86.8349 96.51 85.8584",
    fill: "url(#paint0_linear_2545_980)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.48 85.8603C99.8641 87.4745 103.689 87.9183 107.352 87.1218C111.016 86.3253 114.311 84.3338 116.72 81.4603C117.332 80.7354 117.881 79.9592 118.36 79.1403C118.879 75.9394 118.331 72.6566 116.801 69.7978C115.27 66.939 112.842 64.6629 109.89 63.3203C111.218 64.4351 112.313 65.8005 113.113 67.3387C113.913 68.8768 114.403 70.5575 114.553 72.2847C114.703 74.012 114.512 75.7519 113.99 77.4052C113.468 79.0585 112.625 80.5928 111.51 81.9203C109.725 84.0487 107.323 85.5708 104.637 86.2765C101.95 86.9822 99.1105 86.8368 96.51 85.8603",
    fill: "url(#paint1_linear_2545_980)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.06 55.3385C107.347 53.5725 103.118 53.2198 99.1633 54.3464C95.209 55.4731 91.8006 58.0019 89.5759 61.4597C87.3512 64.9175 86.4625 69.0674 87.0762 73.133C87.6898 77.1987 89.7638 80.9014 92.91 83.5485L97.66 77.8785C96.3289 76.7657 95.23 75.4015 94.4262 73.864C93.6223 72.3264 93.1292 70.6455 92.9751 68.9174C92.8209 67.1892 93.0087 65.4476 93.5277 63.7921C94.0468 62.1365 94.8868 60.5994 96 59.2685C97.7844 57.1394 100.186 55.6175 102.874 54.9135C105.561 54.2094 108.401 54.3579 111 55.3385",
    fill: "url(#paint2_linear_2545_980)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.06 55.3408C107.238 53.5095 102.867 53.1829 98.815 54.4261C94.7632 55.6692 91.3274 58.391 89.19 62.0508C88.778 64.5781 89.0306 67.1693 89.923 69.5695C90.8154 71.9697 92.3169 74.0964 94.28 75.7408C95.3021 76.6073 96.4396 77.3275 97.66 77.8808C96.3289 76.7679 95.23 75.4038 94.4262 73.8662C93.6223 72.3286 93.1293 70.6478 92.9751 68.9196C92.821 67.1915 93.0088 65.4499 93.5278 63.7943C94.0468 62.1387 94.8869 60.6016 96 59.2708C97.7844 57.1416 100.186 55.6198 102.874 54.9157C105.561 54.2116 108.401 54.3602 111 55.3408",
    fill: "url(#paint3_linear_2545_980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 71.1983H30.5L17.71 83.9883L19.13 85.4083L34.33 70.1983L19.13 54.9883L17.71 56.3983L30.5 69.1983H0V71.1983Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2545_980",
    x1: 115.551,
    y1: 57.6759,
    x2: 108.403,
    y2: 43.1946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECF2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2545_980",
    x1: 108.685,
    y1: 70.5433,
    x2: 95.5234,
    y2: 92.1567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC52C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F87130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#EF52E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#661EEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2545_980",
    x1: 103.795,
    y1: 41.9835,
    x2: 110.942,
    y2: 56.4648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78F6D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#77D1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#70A4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#661EEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2545_980",
    x1: 85.29,
    y1: 77.7426,
    x2: 97.2177,
    y2: 55.9792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#536EED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#54C3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#64D769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECF2C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2545_980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 191.46,
    height: 138.47,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwishPhone);
export default __webpack_public_path__ + "static/media/swishPhone.be52cb8de9a244d40b1b0cd6fc9817bb.svg";
export { ForwardRef as ReactComponent };